import { createApp } from 'vue';
import signUpStep1 from './index.vue';

const app = createApp(signUpStep1);
const instance = app.mount(document.createElement('div'));
document.body.appendChild(instance.$el);

const step1 = {
  show(options = {}) {
    instance.options = options;
    instance.show();
  },

  hide() {
    instance.hide();
  },
  // ingenico后端不过后，弹出弹窗，再输入卡号，通过时调用
  successRegister() {},
};

export default step1;
